export function transformHeadlineLevelToTitleLevel(titleLevel: string): number {
  switch (titleLevel) {
    case 'H1':
      return 1;
    case 'H2':
      return 2;
    case 'H3':
      return 3;
    case 'H4':
      return 4;
    case 'H5':
      return 5;
    case 'H6':
      return 6;
    case 'P':
      return 7;
    default:
      return 7;
  }
}
